import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ProductState } from '../types';

const initialState: ProductState = {};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProduct: (state, { payload }: PayloadAction<any>) => {
      state.product = payload;
    },
  },
});

export const { setProduct } = productSlice.actions;
